import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';

import SnapshotCashFlow from 'Components/UI/Snapshot/CashFlow';

const styles = () => ({
  container: {}, // Not used -- just to get around a console error
  root: {},
});

const View = ({
  className,
  classes,
}) => {
  return (
    <SnapshotCashFlow
      className={classNames(classes.root, className)}
      elevation={0}
    />
  );
};

View.defaultProps = {
  className: '',
};

View.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(View);
